import type { FC } from 'react'

import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LeverageFacebookAdsImage from './LeverageFacebookAdsImage'

const copy = {
  heading: `Leverage all of Facebook's Ad products in minutes`,
  description: `Instrument Segment once and access the full Facebook Ads suite for a unified customer experience.`,
}

const LeverageFacebookAds: FC = () => {
  return (
    <Wrapper>
      <SectionBase variant="2Col" copyVariant="narrow" reverse={true}>
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>

        <Section.Contents>
          <LeverageFacebookAdsImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section``

export default LeverageFacebookAds
